'use client';

import React from 'react';
import {
  Plus,
  Lock,
  Play,
  Clock,
  FileCheck,
  GraduationCap,
} from 'lucide-react';


export default function SuperAdminDashboard() {
  return (
    <div className="min-h-screen text-slate-800 antialiased relative">
      <div className="mx-auto max-w-8xl">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="flex flex-col gap-6 lg:col-span-8">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
                  Platform Overview: Test Data
                </h1>
              </div>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-2">
                  <div className="flex flex-col items-center justify-center rounded-2xl bg-[#D6F3F8] px-4 py-2 text-center min-w-[65px]">
                    <span className="text-xl font-bold text-slate-900">42</span>
                    <span className="text-[11px] font-medium text-slate-500">Kindergartens</span>
                  </div>
                  <div className="relative flex flex-col items-center justify-center rounded-2xl bg-[#DCF8CE] px-4 py-2 text-center min-w-[65px]">
                    <span className="absolute -top-2 right-1 text-xs">🎉</span>
                    <span className="text-xl font-bold text-slate-900">316</span>
                    <span className="text-[11px] font-medium text-slate-500">Teachers</span>
                  </div>
                  <div className="flex flex-col items-center justify-center rounded-2xl bg-white px-4 py-2 text-center min-w-[65px] shadow-sm">
                    <span className="text-xl font-bold text-slate-900">7</span>
                    <span className="text-[11px] font-medium text-slate-500">Pending</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="min-h-[580px] rounded-3xl bg-slate-100/50 p-6 backdrop-blur-sm border border-white/40">
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <div className="relative rounded-3xl bg-white p-5 shadow-sm border border-slate-100">
                  <button title="Suspend kindergarten" className="absolute -top-3 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#DCF8CE] text-slate-700 shadow-sm hover:scale-105 transition">
                    <Plus className="h-4 w-4" />
                  </button>
                  <h3 className="text-lg font-bold text-slate-900 leading-snug">
                    Little Explorers<br />Kindergarten
                  </h3>
                  <p className="mt-2 text-xs text-slate-500 leading-relaxed">
                    Prishtina, Perlat Rexhepi Str. · 8 teachers · 96 children enrolled.
                  </p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-slate-800">
                      Verified ✅
                    </span>
                  </div>
                </div>

                <div className="relative rounded-3xl bg-white p-5 shadow-sm border border-slate-100">
                  <button title="View teacher roster" className="absolute -top-3 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#DCF8CE] text-slate-700 shadow-sm hover:scale-105 transition">
                    <GraduationCap className="h-4 w-4" />
                  </button>
                  <h3 className="text-lg font-bold text-slate-900 leading-snug">
                    Sunshine Kids<br />Academy
                  </h3>
                  <p className="mt-2 text-xs text-slate-500 leading-relaxed">
                    Prizren, Nena Tereze Blvd. · 12 teachers · 140 children enrolled.
                  </p>

                  <div className="mt-4 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-800">
                      Pending Review ⏳
                    </span>
                  </div>
                </div>

                <div className="relative col-span-1 rounded-3xl bg-[#F3E2FF] p-5 shadow-lg border border-purple-200/50 md:-rotate-2 transition hover:rotate-0">
                  <h3 className="text-lg font-bold text-slate-900 leading-snug">
                    HTML Basics Course<br />10-16
                  </h3>
                  <p className="mt-2 text-xs text-slate-600 leading-relaxed">
                    Uploaded by teacher Elira Krasniqi · '1 Qershori' Primary School · 3 modules · 12 lessons
                  </p>
                  <div className="absolute right-4 top-6 flex h-14 w-14 items-center justify-center rounded-full bg-white/90 shadow-md">
                    <Play className="h-6 w-6 text-slate-900 fill-slate-900 translate-x-0.5" />
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="inline-flex items-center gap-1.5 rounded-full bg-white/80 px-3 py-1 text-xs font-medium text-slate-700 backdrop-blur-sm">
                      <Clock className="h-3.5 w-3.5" />
                      <span>Uploaded 2h ago</span>
                    </div>
                    <div className="flex -space-x-2">
                      <img className="inline-block h-10 w-10 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop" alt="Parent" />
                    </div>
                  </div>
                </div>

                <div className="relative rounded-3xl bg-white p-5 shadow-sm border border-slate-100">
                  <div className="absolute top-4 right-4 text-slate-400">
                    <Lock className="h-4 w-4" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 leading-snug">
                    Rainbow<br />Kindergarten
                  </h3>
                  <p className="mt-2 text-xs text-slate-500 leading-relaxed">
                    Awaiting business license &amp; safety certificate verification.
                  </p>

                  <div className="mt-4 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                      Pending Review ⏳
                    </span>
                  </div>
                </div>

                <div className="relative rounded-3xl bg-white p-5 shadow-sm border border-slate-100 opacity-90">
                  <div className="absolute top-4 right-4 text-slate-400">
                    <Lock className="h-4 w-4" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 leading-snug">
                    Little Stars<br />Kindergarten
                  </h3>
                  <p className="mt-2 text-xs text-slate-500 leading-relaxed">
                    Registration submitted · awaiting document verification.
                  </p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                      Pending Review ⏳
                    </span>
                  </div>
                </div>
              </div>

              {/* <div className="fixed bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full bg-slate-900 p-1.5 shadow-xl">
                <button title="Kindergartens" className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-slate-900">
                  <Building2 className="h-4 w-4" />
                </button>
                <button title="Teachers" className="flex h-8 w-8 items-center justify-center rounded-full bg-[#D6F3F8] text-slate-900">
                  <GraduationCap className="h-4 w-4" />
                </button>
                <button title="Parents" className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F3E2FF] text-slate-900">
                  <Users className="h-4 w-4" />
                </button>
                <button title="Lectures" className="flex h-8 w-8 items-center justify-center rounded-full bg-[#FEF3D6] text-slate-900">
                  <Video className="h-4 w-4" />
                </button>
                <button title="Support inbox" className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-800 text-white hover:bg-slate-700">
                  <MessageCircle className="h-4 w-4" />
                </button>
                <button title="Approvals" className="flex h-8 w-8 items-center justify-center rounded-full bg-[#DCF8CE] text-slate-900">
                  <ShieldCheck className="h-4 w-4" />
                </button>
                <button title="Add kindergarten" className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-800 text-white hover:bg-slate-700">
                  <Plus className="h-4 w-4" />
                </button>
                <div className="h-4 w-px bg-slate-700 mx-1"></div>
                <button title="Roles & permissions" className="flex h-8 w-8 items-center justify-center rounded-full text-slate-400 hover:text-white">
                  <Lock className="h-4 w-4" />
                </button>
              </div> */}


            </div>
          </div>
          <div className="flex flex-col gap-6 lg:col-span-4 border-l-1 border-gray-300 border-dashed">
            <div className="px-4">
              <h2 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
                Approvals &amp; Activity
              </h2>
            </div>
            <div className="flex flex-col gap-4 rounded-3xl bg-slate-100/50 p-2.5 border border-white/40">
              <div className="rounded-2xl bg-sky-100/60 p-2.5 backdrop-blur-sm border border-cyan-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img className="h-7 w-7 rounded-full object-cover" src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop" alt="Director" />
                    <span className="text-xs font-semibold text-slate-800">New Kindergarten</span>
                  </div>
                  <span className="text-xs font-medium text-slate-500">Mo, 13.07</span>
                </div>

                <p className="mt-3 text-xs text-slate-700 font-medium leading-relaxed">
                  Blue Sky Kindergarten submitted registration documents and is awaiting verification.
                </p>
                <div className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-white py-2 text-xs font-semibold text-slate-800 shadow-sm">
                  <FileCheck className="h-3.5 w-3.5 text-slate-500" />
                  <span>Review Documents</span>
                </div>
              </div>
              <div className="rounded-2xl bg-purple-100/60 p-2.5 backdrop-blur-sm border border-purple-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-purple-700">👩‍🏫 New Teacher</span>
                  </div>
                  <span className="text-xs font-medium text-slate-500">Tu, 14.07</span>
                </div>

                <p className="mt-3 text-xs text-slate-700 font-medium leading-relaxed">
                  Arben Hoxha applied to teach at Sunshine Kids Academy — background check pending.
                </p>
              </div>
              <div className="rounded-2xl bg-amber-100/70 p-2.5 backdrop-blur-sm border border-amber-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-amber-800">📌 Support Ticket</span>
                  </div>
                  <span className="text-xs font-medium text-slate-500">We, 15.07</span>
                </div>

                <p className="mt-3 text-xs text-slate-700 font-medium leading-relaxed">
                  Parent Vjosa Krasniqi reported a video playback issue on the &quot;Shapes &amp; Colors&quot; lecture.
                </p>
              </div>
              <div className="relative rounded-2xl bg-emerald-100 p-2.5 shadow-md border border-emerald-200 rotate-1 transition hover:rotate-0">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-emerald-900">🎬 Lecture Review</span>
                  </div>
                  <span className="text-xs font-medium text-slate-600">Th, 16.07</span>
                </div>

                <p className="mt-3 text-xs text-slate-800 font-medium leading-relaxed">
                  &quot;Animals &amp; Sounds&quot; uploaded by teacher Fjolla Berisha is awaiting content approval.
                </p>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
}
